import { createAction } from '@reduxjs/toolkit';
export const UPDATE_ANALYTIC_TEAM_REPORT_CONFIG = 'UPDATE_ANALYTIC_TEAM_REPORT_CONFIG';
export const updateAnalyticTeamReportConfigAction = createAction(UPDATE_ANALYTIC_TEAM_REPORT_CONFIG);